import React from 'react';
import Button from '../ui/Button';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-info">
          <span className="footer-brand">BRIVA</span>
          <span>&copy; {new Date().getFullYear()}</span>
          <span aria-hidden="true">&bull;</span>
          <span className="footer-tagline">Emerging tech, put to work.</span>
        </div>
        <div className="footer-info">
          <span>Singapore</span>
          <span aria-hidden="true">&bull;</span>
          <Button
            onClick={() => document.getElementById('top')?.scrollIntoView({ behavior: 'smooth' })}
          >
            Back to top
          </Button>
        </div>
      </div>
    </footer>
  );
}
